import { CipherService } from "../../shared/services/CipherService";

export type AuthUser = {
  token?: string;
  mobileNumber: string;
  uuid?: string;
  name?: string;
  userId?: string;
  raw?: any;
  userType?: string;
};

const KEY_USER = "auth_user";

export const AuthStorage = {
  async setUser(user: AuthUser) {
    await CipherService.set(KEY_USER, JSON.stringify(user));
  },

  async getUser(): Promise<AuthUser | null> {
    const raw = await CipherService.get(KEY_USER);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as AuthUser;
    } catch {
      return null;
    }
  },

  async clear() {
    await CipherService.remove(KEY_USER);
  },
};
